import * as angular from 'angular';
import {IController} from 'angular';
import {SplitService} from "../../services/split-service.service";

export class ProgramTypeSelectListComponent implements IController {

  selectedProgramId: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  public queryString: string;

  constructor(private splitService: SplitService) {
  }

  $onInit() {
    if (!this.options?.length) {
      this.options = this.splitService.getSiteProgramTypes();
    }
  }

  submitQuery(query) {
    this.queryString = query;
  }


}

angular
  .module('bringoz.admin.commons')
  .component('programTypeSelectList', {
    bindings: {
      selectedProgramId: '<',
      options: '<',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./program-type-select-list.html').default,
    controller: ProgramTypeSelectListComponent
  });
